module.exports = __webpack_public_path__ + "static/media/short_text-24px.0726694c.svg";